import * as React from 'react';
import { IconFinanceArrowBoldDown16, IconFinanceArrowBoldUp16 } from '@cian/ui-kit-design-tokens/icons';
import { TPriceDiffTrend } from '../../../types/developerValuation/developerValuationPriceDynamics';

interface IPriceDiffProps {
  diffTrend: TPriceDiffTrend;
}

export const PriceDiff: React.FC<IPriceDiffProps> = ({ diffTrend }) => {
  return diffTrend === 'increase' ? (
    <IconFinanceArrowBoldUp16 display="block" color="icon-main-default" />
  ) : (
    <IconFinanceArrowBoldDown16 display="block" color="icon-main-default" />
  );
};
